import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

import uuid from 'react-uuid';
import { ChipListComponent, ChipsDirective, ChipDirective } from '@syncfusion/ej2-react-buttons';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import { LocalizationContext } from '../../App';
import NavLink from 'react-bootstrap/NavLink';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { ReactSession } from 'react-client-session';
import { useNavigate } from 'react-router-dom';
import { RadioButtonComponent } from '@syncfusion/ej2-react-buttons';
import Container from 'react-bootstrap/Container'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Button from 'react-bootstrap/Button';
import TextField from "@mui/material/TextField";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { inputLabelClasses } from "@mui/material/InputLabel";
import { styled } from "@mui/material/styles";
import { useBeforeunload } from 'react-beforeunload';
import Backdrop from '@mui/material/Backdrop';
import AwesomeMarkers from 'leaflet.awesome-markers';
import * as Leaflet from 'leaflet';
import { MapContainer, TileLayer, Marker, Popup, Circle, Polygon, MapConsumer, useMapEvents } from 'react-leaflet';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import cloneDeep from 'lodash/cloneDeep';


const LoupeMappingSimpleMarker = props => {

    const item = props.currentItem;
    const selectedMapMode = props.selectedMapMode;
    const markerSelectedCallbackHandler = props.markerSelectedCallbackHandler;

    
    const [ markers ] = useState( item['selectedValues']);
    item['selectedValues'] = markers;
    
    const [state, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);

    const [ showSnack, setShowSnack ] = useState(false);



    const markerStyle = ( item.markerStyle != "" ) ? Leaflet.AwesomeMarkers.icon({     
        icon: item.markerStyle.split(':')[0],
        prefix: "fa",
        markerColor: item.markerStyle.split(':')[1],
        iconColor: "white",
    }) : "";
    

    const map = useMapEvents({
        click: (e) => {  
            
            if(selectedMapMode == "mapmode_add") {

                var addMarker = true;

                if( item.markerLimit != -1 && ( markers.length >= item.markerLimit ) ) {
                    addMarker = false;
                    setShowSnack(true);
                }   

                if(addMarker == true ) {
                    
                    // deep-clone activity items to created marker
                    var markerItems = cloneDeep( item.markerItems );
                    var idx = markers.push({ type : 'simple-marker', latitude : e.latlng.lat, longitude : e.latlng.lng, markeritems : markerItems }) -1;                         
                    forceUpdate();

                    if(item.hasMarkerItems) {
                        markerSelectedCallbackHandler(markers[idx]);
                    }
                    
                    item.validator.touched();
                    if(item.validator.instantRevalidation) {
                        item.validator.revalidate();
                    }
                }

            }
        },
        
    });
      
    

    return(

        <LocalizationContext.Consumer>
            { ({strings}) => 

        <React.Fragment>

            { markers.map( (m, idx) => {
                const position = [ m.latitude, m.longitude ];           
                return( 
                        <Marker eventHandlers={{
                            click: (e) => { 

                                if(selectedMapMode === null && item.hasMarkerItems) {
                                    markerSelectedCallbackHandler(markers[idx]);
                                }

                                if(selectedMapMode == "mapmode_delete") {
                                    markers.splice( idx, 1 );
                                    forceUpdate();
                                }                     
                            },
                        }} position={position} key={idx} {...markerStyle != "" && { 'icon' : markerStyle }} />
                );
            })}

            <Backdrop onClick={() => setShowSnack(false)} className="point" open={showSnack} sx={{ color: '#000', zIndex : 9000}}/>
            <Snackbar sx={{zIndex : 9001}} open={showSnack} autoHideDuration={6000} anchorOrigin={{horizontal:'right',vertical:'top'}} onClick={() => setShowSnack(false)}>
            <Alert severity="error" className="padleft point text-start" sx={{ width: '100%' }}>
                        {strings.getString("errors.mapping.marker.limit")}
                    </Alert>
            </Snackbar>

        </React.Fragment>

        }
        </LocalizationContext.Consumer>
        
    );

}
export default LoupeMappingSimpleMarker;